<template>
  <div class="content">
      <!-- 展示的搜索条件 -->
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId" v-if="adminShow">
        <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="search" clearable >
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId" />
        </el-select>
      </el-form-item>
      <el-form-item prop="orderMode" >
        <el-select v-model="queryParams.orderMode" filterable placeholder="支付方式" @change="search" clearable>
          <el-option v-for="(item,index) in selectOrderMode" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="payType" >
        <el-select v-model="queryParams.payType" filterable placeholder="收支类型" @change="search" clearable>
          <el-option v-for="(item,index) in options" :key="index" :label="item.operationName" :value="item.cardStatus"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" class="el-icon-download" @click="handleExport" v-hasPermi="['person:userAccount:export']">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="orderId" label="订单号" align="center" width="220px"></el-table-column>
      <el-table-column prop="company" label="代理商" align="center" v-if="adminShow" width="220px"></el-table-column>
      <el-table-column prop="payType" label="收支类型" align="center"  width="120px">
        <template slot-scope="{row}">
          <span v-if="row.payType == '1'">收入</span>
          <span v-else>支出</span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="金额" align="center" width="120px">
        <template slot-scope="{row}">
          <span v-if="row.payType == '1'" style="color: #ff4949">{{row.money>0?"+" + row.money:row.money}}</span>
          <span v-if="row.payType == '2'" style="color: #13ce66">{{row.money}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="accountAmount" label="账户余额" align="center" width="120px"></el-table-column>
      <el-table-column prop="orderMode" label="支付方式" align="center">
        <template slot-scope="{row}">
          <span v-if="row.orderMode == '1'">佣金充值</span>
          <span v-else-if="row.orderMode == '2'">用户公众号充值</span>
          <span v-else-if="row.orderMode == '3'">系统充值</span>
          <span v-else-if="row.orderMode == '4'">微信充值</span>
          <span v-else-if="row.orderMode == '5'">支付宝充值</span>
          <span v-else>余额支出</span>
        </template>
      </el-table-column>
      <el-table-column prop="accountAmount" label="支付状态" align="center" width="120px">
        <template slot-scope="{row}">
          <span v-if="row.status == '0'">充值失败</span>
          <span v-else>充值成功</span>
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="操作时间" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
    </el-table>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { accountList,exportAccount } from "@/api/api.js"; //金额的收支明细
import { agentList } from "@/api/api.js";//代理商
export default {
  data() {
    return {
      page: 1,
      pageSize: 20,
      total: 0,
      queryParams:{},
      tableData:[],
      dateRange:[],
      options: [
        {
          cardStatus: "1",
          operationName: "收入"
        },
        {
          cardStatus: "2",
          operationName: "支出"
        },
      ],
      agentList:[],
      selectOrderMode:[
        { value: 1, label: "佣金充值"},
        { value: 3, label: "系统充值"},
        { value: 4, label: "微信充值"},
        { value: 6, label: "余额支出"},
        { value: 5, label: "支付宝充值"},
        { value: 2, label: "用户公众号充值"},
      ]
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    initData() {
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      accountList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
      };
      exportAccount(params).then(res=>{
        this.$notify.info({
          title: "提示",
          message: "账户明细已导出，请在任务中心查看进度",
          duration: 1000
        });
      })

    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.dateRange = [],
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        this.agentList = res.data.data;
      });
    },
  },
  mounted() {

  },
  created() {
    this.initData();
    this.queryAgentList();
  }
};
</script>
<style scoped lang="less">
</style>


